import {Button, Dialog, DialogActions, DialogContent} from "@material-ui/core";
import DefaultType from "../../../../../../../Utils/Form/FormDynamic/Fields/DefaultType/DefaultType";
import React, {useEffect, useState} from "react";

const ChoiceFormDialog = ({dialogState, onClose, saveValues}) => {
    const [value, setValue] = useState();

    useEffect(() => {
        if (dialogState.isOpen) {
            if (dialogState.record) {
                setValue(dialogState.record);
            }
        }else{
            setValue({});
        }
    }, [dialogState.isOpen]);

    function onChange(v, p) {
        setValue((prev) => {
            return {
                ...prev,
                [p]: v
            }
        })
    }

    return (
        <Dialog open={dialogState.isOpen} onClose={onClose}>
            <DialogContent>
                <DefaultType
                    values={value}
                    field={{
                        path: 'id',
                        label: 'Answer Id',
                        autofocus: true,
                    }}
                    labelStyles={{
                        width: 130
                    }}
                    setValue={onChange}
                />
                <DefaultType
                    values={value}
                    field={{
                        path: 'label',
                        label: 'Label',
                        multiLanguage: true,
                    }}
                    labelStyles={{
                        width: 130
                    }}
                    setValue={onChange}
                />
                <DefaultType
                    values={value}
                    field={{
                        path: 'points',
                        label: 'Points',
                        type: 'number'
                    }}
                    labelStyles={{
                        width: 130
                    }}
                    setValue={onChange}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        saveValues(value);
                        onClose();
                    }}
                    variant={"contained"} color={'primary'} size={'small'}
                >
                    Save
                </Button>
                <Button
                    onClick={onClose}
                    variant={"contained"} color={'default'} size={'small'}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    )
}
export default ChoiceFormDialog